/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientAssignedPermissionViewModel } from '../../models/client-assigned-permission-view-model';

export interface GetClientAssignedPermission$Params {
      body?: {
'clientID'?: number;
'permissionID'?: number;
}
}

export function GetClientAssignedPermission(http: HttpClient, rootUrl: string, params?: GetClientAssignedPermission$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientAssignedPermissionViewModel>> {
  const rb = new RequestBuilder(rootUrl, GetClientAssignedPermission.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ClientAssignedPermissionViewModel>;
    })
  );
}

GetClientAssignedPermission.PATH = '/api/Permissions/GetClientAssignedPermission';
